import React, { useContext, useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import { getTeamDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import Team from "./Team";

function Teams() {
  const { appState, dispatch } = useContext(AppContext);
  const { ourTeam, ourTeamLoader } = appState;
  const myRef = useRef(null);

  useEffect(() => {
    getTeamDetails(appState, dispatch)
  }, [])

  return (
    <>
      {
        ourTeamLoader ?
          <div className='home-spinner'>
            <ClipLoader color={"#2A5350"} loading={true} size={60} />
          </div>
          :
          Object.keys(ourTeam).length &&
          <>
            <Breadcrumb
              pageName={ourTeam.header_team_section.title || "our team"}
              pageTitle={ourTeam.header_team_section.title || "our team"}
              id={`#${ourTeam.header_team_section.title}`}
              image={ourTeam.header_team_section.banner_image}
              myRef={myRef}
            />
            <div className="team-section2 mb-50" ref={myRef} >
              <div className="container">
                <div className="row justify-content-center" data-aos="fade-up">
                  <div className="section-title2 primary3">
                    <span>{ourTeam.header_team_section.title}</span>
                  </div>
                </div>
                {
                  ourTeam.team_section.map((section, index ) => {
                    return <Team team={section}  key={section.id || index}  />
                  })
                }
              </div>
            </div>
          </>
      }
    </>
  );
}

export default Teams;
